import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

import type { GlobalPermissions } from '../../data-contract/global-search';
import { globalOptionsSchema } from '../../data-contract/global-search';

export const useGlobalPermissions = (): UseQueryResult<GlobalPermissions, Error> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = '/global/options';

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(globalOptionsSchema, {
                pathname,
            });

            if (result.isOk) {
                const data = result.value;

                return {
                    ...data,
                    canUserSearch:
                        data.canSearchUsers ||
                        data.canSearchLearningOpportunities ||
                        data.canSearchJobs ||
                        data.canSearchSkills,
                    canUserTalentDirectory:
                        data.canDirectoryUsers ||
                        data.canDirectoryLearningOpportunities ||
                        data.canDirectoryJobs ||
                        data.canDirectorySkills,
                };
            }

            throw result.error;
        },
        queryKey: [pathname, 'GET'],
        refetchOnMount: false,
    });
};
